import React from "react";
import QuestionPapers from "../../data/question-papers.json";

const QuestionPapersMain = () => {
  return (
    <div className="container my-5" style={{ paddingBottom: "80px" }}>
      <p style={{ paddingLeft: "6px", fontSize: 12 }}>
        Source: https://upsc.gov.in/
      </p>
      <div className="accordion" id="questionPapersAccordion">
        {QuestionPapers.map((yearData, index) => (
          <div className="accordion-item" key={yearData.id}>
            <h2 className="accordion-header" id={`heading${index}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded={yearData.id === 1 ? "true" : false}
                aria-controls={`collapse${index}`}
              >
                {yearData.year}
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              className={
                yearData.id === 1
                  ? "accordion-collapse collapse show"
                  : "accordion-collapse collapse"
              }
              aria-labelledby={`heading${index}`}
              data-bs-parent="#questionPapersAccordion"
            >
              <div className="accordion-body">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Paper</th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(yearData.questionPapers).map(
                      ([paper, link]) => (
                        <tr key={paper}>
                          <td>{paper}</td>
                          <td>
                            <a
                              href={link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-primary"
                            >
                              Download
                            </a>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuestionPapersMain;
